import React from 'react';
import { CTAButton, TrustLine } from './CTAButton';
import { BOX_IMAGE, PURCHASE_ANCHOR } from '../data/content';
export function Hero() {
  return <header className="bg-deep px-4 pb-5 pt-4 text-center sm:px-6" data-id="element-76" data-mp="eilc6zjmglae">
      <h1 className="font-heading text-[1.45rem] font-extrabold uppercase leading-[1.06] text-white sm:text-4xl" data-id="element-77" data-mp="9luxafjjzvqk">
        The Complete Visual Study System for{' '}
        <span className="text-glow" data-id="element-78" data-mp="1297ahz3tqr77">Ophthalmology</span>
      </h1>
      <p className="mx-auto mt-2 max-w-xl text-[0.86rem] leading-snug text-white/85 sm:text-base" data-id="element-79" data-mp="127eereur1rdz">
        Stop studying ophthalmic findings as isolated information. Access visual
        atlases, annotated comparisons, imaging patterns, reference guides,
        recognition tools and multimodal resources. Keep essential ophthalmic
        patterns organized in one professional system.
      </p>
      <p className="mt-1.5 font-heading text-[0.8rem] font-bold uppercase text-turq sm:text-base" data-id="element-80" data-mp="3czfkfwx3o34z">
        Less time searching. More visual clarity for every study session.
      </p>

      <a href={PURCHASE_ANCHOR} className="mt-3 block" data-id="element-81" data-mp="3j924lm8avmuh">
        <img src={BOX_IMAGE} alt="OPHTHALMOLOGY VISUAL ATLAS™ complete 6-in-1 visual study system box set" className="mx-auto w-full max-w-[300px] drop-shadow-2xl sm:max-w-sm" data-id="element-82" data-mp="3o859n6oa5t2g" />
      </a>

      <div className="mx-auto mt-3 max-w-md" data-id="element-83" data-mp="3e84nlcz10yuk">
        <CTAButton label="👁️ Yes! I want the complete system" data-id="element-84" data-mp="30i18d5yke5em" />
        <p className="mt-2 font-heading text-[0.7rem] font-extrabold uppercase tracking-wide text-glow sm:text-sm" data-id="element-85" data-mp="30ggfrlvt8wje">
          Get Ophthalmology Visual Atlas™ today
        </p>
        <TrustLine className="mt-1 !text-white/80" data-id="element-86" data-mp="2qkwkn1p2m1vp" />
      </div>
    </header>;
}